// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const LowPriorityIcon = createSvgIcon(
  <svg width={24} height={24} fill="currentColor" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      d="M10.1 17.87h-.16A6.94 6.94 0 0 1 9.94 4h1.76a.65.65 0 0 1 0 1.3H9.94a5.64 5.64 0 0 0 0 11.27h.24l-1.2-1.2a.65.65 0 0 1 .92-.91l2.26 2.26c.26.25.26.67 0 .92L9.9 19.9a.65.65 0 0 1-.92 0 .65.65 0 0 1 0-.92zM15.46 5.3a.65.65 0 0 1 0-1.3h4.07a.65.65 0 1 1 0 1.3zm0 3.14a.65.65 0 0 1 0-1.3h4.07a.65.65 0 0 1 0 1.3zm0 3.15a.65.65 0 0 1 0-1.3h4.07a.65.65 0 1 1 0 1.3zm0 3.14a.65.65 0 0 1 0-1.3h4.07a.65.65 0 1 1 0 1.3zm0 3.14a.65.65 0 0 1 0-1.3h4.07a.65.65 0 0 1 0 1.3z"
      clipRule="evenodd"
    />
  </svg>,
  "LowPriority",
);
export default LowPriorityIcon;
